import { render, staticRenderFns } from "./SectionContent.vue?vue&type=template&id=bdcb82f6&"
import script from "./SectionContent.vue?vue&type=script&lang=ts&"
export * from "./SectionContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports